import {Box, Flex, useMediaQuery} from '@chakra-ui/react'
import Header from './Header'
import Footer from './Footer'
import Situation from './Situation'
import ChoosePicture from './ChoosePicture'
import Pronounce from './Pronounce'
import ChooseAnswer from './ChooseAnswer'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import RestScreen from './RestScreen'
import {
  updateIsCurrentChoose,
  updateIsShowBtnContinue,
} from '@redux/vocabulary/vocabulary'
import vocabularyRequest from '@apis/vocabulary'
import {useLocation, useNavigate} from 'react-router-dom'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import {isParamsValid} from '@utils'

const Vocabulary = () => {
  const {currentChoose, isShowBtnContinue} = useSelector(
    (state: any) => state.vocabulary,
  )
  const location = useLocation()
  const {setId} = location.state || {}
  const [vocabularyData, setVocabularyData] = useState<any>()
  const [currentVocabulary, setCurrentVocabulary] = useState<any>()
  const [currentIndexVocabulary, setCurrentIndexVocabulary] = useState(0)
  const [currentIndexQuestion, setCurrentIndexQuestion] = useState(0)
  const [screenReportError, setScreenReportError] = useState<any>()
  const [isLargerThan1280] = useMediaQuery('(min-width: 1600px)')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isParamsValid([setId])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!setId) return
    getDetailVocabulary()
  }, [])

  useEffect(() => {
    if (!vocabularyData) {
      return
    }
    setCurrentVocabulary(
      vocabularyData[currentIndexVocabulary]?.questions[currentIndexQuestion],
    )
  }, [vocabularyData, currentIndexVocabulary, currentIndexQuestion])

  useEffect(() => {
    dispatch(updateIsCurrentChoose(null))
    dispatch(updateIsShowBtnContinue(false))
  }, [currentIndexQuestion])

  useEffect(() => {
    if (!currentVocabulary) return
    switch (currentVocabulary?.vocabularyQuestionData?.question_type) {
      case '"LISTEN_CONVERSATION"':
        setScreenReportError(SCREEN_REPORT_ERROR.XEM_TINH_HUONG)
        break
      case 'CHOOSE_VOCABULARY_MEANING':
        setScreenReportError(SCREEN_REPORT_ERROR.CHON_HINH_ANH)
        break
      case 'SPEAKING':
        setScreenReportError(SCREEN_REPORT_ERROR.PHAT_AM)
        break
      case 'CHOOSE_ANSWER':
        setScreenReportError(SCREEN_REPORT_ERROR.TRAC_NGHIEM)
        break
      default:
        console.warn(
          'Unknown progressType:',
          currentVocabulary?.vocabularyQuestionData?.progressType,
        )
        setScreenReportError(SCREEN_REPORT_ERROR.XEM_TINH_HUONG)
    }
  }, [currentVocabulary])

  const getDetailVocabulary = async () => {
    const res = await vocabularyRequest.getDetailVocabulary(setId)
    if (res.status === 200) {
      setVocabularyData(res.data.data)
    }
  }

  return (
    <Flex
      mx={{base: '-16px', md: 'unset'}}
      h={'100vh'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      bg={'#F6F6F6'}>
      <Flex
        className="container-xl"
        flex={1}
        flexDirection={'column'}
        w={'100%'}>
        <Header
          vocabularyData={vocabularyData}
          currentVocabulary={currentVocabulary}
          currentIndexVocabulary={currentIndexVocabulary}
        />
        <Box
          className="scroll-bar"
          flex={1}
          borderRadius={'40px'}
          w={'100%'}
          maxW={'1000px'}
          mx={'auto'}
          p={{base: '16px', md: '24px'}}
          bg={'white'}
          overflow={'auto'}
          maxH={
            isLargerThan1280
              ? '600px'
              : currentIndexQuestion === 1 ||
                  currentIndexQuestion === 2 ||
                  currentIndexQuestion === 4
                ? '490px'
                : '420px'
          }>
          {currentIndexQuestion === 0 && (
            <Situation currentVocabulary={currentVocabulary} />
          )}
          {currentIndexQuestion === 1 && (
            <ChoosePicture
              currentVocabulary={currentVocabulary}
              setCurrentIndexQuestion={setCurrentIndexQuestion}
            />
          )}
          {currentIndexQuestion === 2 && (
            <Pronounce
              currentVocabulary={currentVocabulary}
              setCurrentIndexQuestion={setCurrentIndexQuestion}
            />
          )}
          {currentIndexQuestion === 3 && (
            <ChooseAnswer currentVocabulary={currentVocabulary} />
          )}
          {currentIndexQuestion === 4 && (
            <RestScreen
              vocabularyData={vocabularyData}
              setCurrentIndexQuestion={setCurrentIndexQuestion}
              setCurrentIndexVocabulary={setCurrentIndexVocabulary}
              currentIndexVocabulary={currentIndexVocabulary}
            />
          )}
        </Box>
      </Flex>
      {((currentIndexQuestion === 0 && isShowBtnContinue) ||
        (currentIndexQuestion === 3 && currentChoose)) && (
        <Footer
          vocabularyData={vocabularyData}
          currentVocabulary={currentVocabulary}
          currentIndexVocabulary={currentIndexVocabulary}
          currentIndexQuestion={currentIndexQuestion}
          setCurrentIndexQuestion={setCurrentIndexQuestion}
        />
      )}
      {screenReportError && (
        <FormReportError
          feature={FEATURE_REPORT_ERROR.VOCABULARY_STUDY}
          screen={screenReportError}
        />
      )}
    </Flex>
  )
}

export default Vocabulary
